export const EAS_UPDATE_STORAGE_KEY = "x-whoosh-patron-eas-version";
export const EAS_UPDATE_IS_OUTDATED_KEY = "x-whoosh-patron-eas-is-outdated";
export const CLUB_SLUG_STORAGE_KEY = "x-whoosh-member-club-slug";
export const STAFF_USER_CONTEXT = "STAFF";
export const SCHEMA_VERSION_HEADER_KEY = "x-whoosh-patron-schema-version";
export const SCHEMA_VERSION_IS_OUTDATED_KEY =
  "x-whoosh-patron-schema-is-outdated";
export const WHOOSH_SESSION_STORAGE_KEY = "x-whoosh-session-key";
export const WHOOSH_SESSION_GENERATION_STORAGE_KEY = "WhooshSessionGeneration";
export const WHOOSH_SESSION_INVALIDATED_STORAGE_KEY =
  "WhooshSessionInvalidated";
export const WHOOSH_SESSION_CREDENTIAL_CHANGED_EVENT =
  "whoosh-session-credential-changed";
export const WHOOSH_SUBSCRIPTION_RECONNECTED_EVENT =
  "whoosh-subscription-reconnected";
